import { createContext, useContext } from 'react';

var ComposableTableContext = createContext(undefined);
/** The TableContect is used to hold all state and callback of a table to be used by child components */
var useTableContext = function () {
    var tableContext = useContext(ComposableTableContext);
    // We don't care if the component using is not under a context provider as all context state is optional
    if (tableContext === undefined) {
        return { rowState: {}, id: "table" };
    }
    return tableContext;
};

/**
 * Row context is used to provide the current rowId to child cells of a row
 */
var RowContext = createContext(undefined);
var useRowContext = function () {
    var rowContext = useContext(RowContext);
    // We don't care if the component using is not under a context provider as all context state is optional
    if (rowContext === undefined) {
        return {};
    }
    return rowContext;
};

export { ComposableTableContext as C, RowContext as R, useRowContext as a, useTableContext as u };
